import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Popover, PopoverAnchor, PopoverContent } from '@fiverr-private/popover';
import { ArrowIcon } from './ArrowIcon';

interface HeaderCollapsibleProps {
  children: React.ReactNode;
  title: string;
}

export const HeaderCollapsible = ({ children, title }: HeaderCollapsibleProps) => (
  <Popover triggerEvent="hover">
    <PopoverAnchor>
      <Stack alignItems="center" gap="1" cursor="pointer">
        <Typography color={{ default: 'grey_900', hover: 'green_700' }} fontWeight="semibold">
          <I18n k={title} />
        </Typography>
        <ArrowIcon />
      </Stack>
    </PopoverAnchor>
    <PopoverContent>
      <Stack direction="column" gap="0">
        {children}
      </Stack>
    </PopoverContent>
  </Popover>
);
